<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div v-if="overlay" class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-skeleton-loader type="text" height="70px" width="200px" />
        </div>
        <div>
          <v-skeleton-loader type="table-heading, table-tbody" />
        </div>
      </div>
      <div v-else class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text">
            Saldo congelado
          </div>
        </div>
        <div>
          <div>
            <v-row>
              <v-col cols="12">
                <div class="mb-3">
                  Órdenes:
                </div>
                <v-data-table
                  :loading-text="table.title"
                  :loading="table.loading"
                  :headers="table.headers"
                  :items="table.data"
                  :items-per-page="table.itemsPerPage"
                  :page="table.page"
                  dense
                  class="elevation-1">
                  <template v-slot:item.uuid="{ item }">
                    <a href="" @click.prevent="openDialog(item)" v-if="purchaseOrderPermissions['read-purchase-orders']">
                      {{ item.uuid }}
                    </a>
                    <label for="" v-else>
                      {{ item.uuid }}
                    </label>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <div :class="`${statusColors[item.status]}--text`">
                      {{ statuses[item.status] }}
                    </div>
                  </template>
                  <template v-slot:item.total="{ item }">
                    <div class="text-right">
                      {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                    </div>
                  </template>
                  <template v-slot:item.createdAt="{ item }">
                    <div class="text-left">
                      {{ $moment(item.order.createdAt).format('DD/MM/YYYY') }}
                    </div>
                  </template>
                  <!-- <template v-slot:item.netTotal="{ item }">
                    <div class="text-right">
                      {{ item.netTotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                    </div>
                  </template> -->
                </v-data-table>
              </v-col>

              <v-col cols="12">
                <v-row>
                  <v-col md="6" />
                  <v-col md="6">
                    <v-card outlined>
                      <div class="d-flex">
                        <!-- <v-col>
                          <div class="mb-2">
                            Total sin impuestos:
                          </div>
                          <div>
                            {{ netTotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </div>
                        </v-col>
                        <v-divider vertical /> -->
                        <v-col>
                          <div class="mb-2">
                            Total:
                          </div>
                          <div class="text-right">
                            {{ total | toFixNumber(2) | numberWithComma | prefix('$') }}
                          </div>
                        </v-col>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
     <detail-dialog
      :dialog="dialog"
      :order="order"
      :isRead="true"
      @close="closeDialog"/>
  </div>
</template>

<script>
import DetailDialog from '@/screens/purchaseOrders/Detail'

export default {
  name: 'AmountWithheldDetail',
  components: {
    DetailDialog
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      table: {
        title: this.$i18n.t('products.sidePanel.loading'),
        loading: false,
        headers: [
          { text: 'Orden de compra', value: 'uuid' },
          { text: 'Fecha de creación OC', value: 'createdAt' },
          { text: 'Area', value: 'area' },
          { text: 'Proveedor', value: 'provider' },
          { text: 'Estatus', value: 'status' },
          { text: 'Total de la orden', value: 'total' }
        ],
        data: [],
        total: 0,
        itemsPerPage: 20,
        page: 1
      },
      statuses: {
        sent: 'Nueva orden',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        received: 'Entregada',
        pending_payment: 'Pendiente de pago',
        paid: 'Cobrada'
      },
      statusColors: {
        created: 'grey',
        sent: 'grey',
        confirmed: 'info',
        canceled: 'red',
        invoiced: 'info',
        invalid: 'red',
        received: 'primary',
        pending_payment: 'primary',
        paid: 'primary'
      },
      order: {},
      dialog: false
    }
  },
  computed: {
    total () {
      return this.table.data.reduce((acc, num) => {
        return acc + num.total
      }, 0)
    },
    purchaseOrderPermissions () {
      return this.$store.state.login.permissions['purchase-orders'].components['purchase-orders-list'].actions
    }
  },
  async mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.load()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    async load () {
      this.overlay = true

      try {
        const data = await this.$api.get('/v1/orders/amount-withheld-orders')
        this.table.data = data.orders
        this.table.total = data.orders.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }

      this.overlay = false
    },
    openDialog (item) {
      this.dialog = true
      this.order = item.order
    },
    closeDialog: function (order) {
      this.dialog = false
      this.order = {}
    }
  }
}
</script>
